import { IUserSettings } from "../helpers/types";
import { I18NEXT_LANGUAGE_KEY } from "./constants";

class LanguageUtil {
  public AVAILABLE_LANGUAGES = {
    en: "en",
    fr: "fr",
    es: "es",
  };

  private normalizeLanguageCode = (langCode: string) => {
    return langCode.split("-")[0];
  };

  public AVAILABLE_LANGUAGES_OPTIONS = [
    {
      label: "Français",
      value: this.AVAILABLE_LANGUAGES.fr,
    },
    {
      label: "English",
      value: this.AVAILABLE_LANGUAGES.en,
    },
    {
      label: "Español",
      value: this.AVAILABLE_LANGUAGES.es,
    },
  ];
  public DEFAULT_LANGUAGE = this.AVAILABLE_LANGUAGES.fr;

  public getCurrentLanguage = (userSettings: IUserSettings | null) => {
    return userSettings?.preferredLang || this.DEFAULT_LANGUAGE;
  };

  public getPublicCurrentLanguage = () => {
    const language = localStorage.getItem(I18NEXT_LANGUAGE_KEY);
    return language ? this.normalizeLanguageCode(language) : this.DEFAULT_LANGUAGE;
  };

  public setCurrentLanguage = async (i18n: any, language: string) => {
    await i18n.changeLanguage(language);
    localStorage.setItem(I18NEXT_LANGUAGE_KEY, language);
  };
}

const languageUtil = new LanguageUtil();

export default languageUtil;
